import { createFileRoute } from '@tanstack/react-router';
import { AppointeeCredentialsDialog } from '@/pages/admin/appointee/appointee-credentials-dialog';

/**
 * Aggiornamento delle credenziali: dialogo sopra la pagina, che il layout
 * tiene già montata. La rotta resta perché il banner della dashboard ci porta
 * con un link.
 */
export const Route = createFileRoute(
  '/admin/_layout/appointee/_layout/credentials'
)({
  component: () => <AppointeeCredentialsDialog />,
});
